import { useContext, useRef } from 'react';

import { type Experience } from '../Experience';
import { type ExperienceEvent } from '../ExperienceEvent';

import { ExperienceTrackerContext } from './ExperienceTrackerContext';

export type ExperienceStartProps = {
	attributes?: object;
	collect?: (events: ExperienceEvent[], experience: Experience) => void;
	id: string;
	name: string;
	onSuccess?: () => void;
};

export function ExperienceStart({
	id,
	name,
	attributes,
	collect,
	onSuccess,
}: ExperienceStartProps) {
	const experienceTracker = useContext(ExperienceTrackerContext);
	const wasCalledRef = useRef<boolean>(false);

	if (!wasCalledRef.current) {
		experienceTracker.start({
			attributes,
			name,
			id,
			collect,
			onSuccess,
		});
		wasCalledRef.current = true;
	}

	return null;
}
